import { upsertClient } from '../../api/companyRecords';

export function isClientArchived(client) {
  return client?.archived === true;
}

export async function setClientArchived(companyId, clientId, archived) {
  if (!companyId || !clientId) {
    throw new Error('Missing company or client id');
  }

  const now = new Date().toISOString();
  await upsertClient({
    companyId,
    id: clientId,
    client: {
      archived: Boolean(archived),
      archivedAt: archived ? now : null,
      updatedAt: now,
    },
  });
}
